const Leaders = [
  {
    name: 'Hitesh Arora',
    image: '../static/media/arora.4d739dc1ef37ec4e728b.png',
    about:
      'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Quo sint excepturi repellat consequuntur at beatae quas corrupti aut vel numquam? Aperiam et neque maxime deleniti enim necessitatibus temporibus nesciunt reprehenderit.',
  },

  {
    name: 'Rishi Arora',
    image: '../static/media/arora.4d739dc1ef37ec4e728b.png',
    about:
      'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Quo sint excepturi repellat consequuntur at beatae quas corrupti aut vel numquam? Aperiam et neque maxime deleniti enim necessitatibus temporibus nesciunt reprehenderit.',
  },

  {
    name: 'Rajesh Kumar Bansal',
    image: '../static/media/arora.4d739dc1ef37ec4e728b.png',
    about:
      'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Quo sint excepturi repellat consequuntur at beatae quas corrupti aut vel numquam? Aperiam et neque maxime deleniti enim necessitatibus temporibus nesciunt reprehenderit.',
  },
]

export default Leaders
